import { combineReducers } from 'redux';

const exchangeCouponInitialState = {
  saveStatus: 0,
  input: {
    exchangeCode: '',
  },
  data: null,
};

function exchangeCouponReducer(state = exchangeCouponInitialState, action) {
  switch (action.type) {
    case 'CHANGE_COUPON_EXCHANGE_INPUT': {
      return {
        ...state,
        input: {
          ...state.input,
          ...action.input,
        },
      };
    }

    case 'EXCHANGE_COUPON': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'EXCHANGE_COUPON_COMPLETION': {
      const { error, data } = action;

      if (error) {
        return {
          ...state,
          saveStatus: 0,
        };
      }

      return {
        ...state,
        saveStatus: 2,
        data,
      };
    }

    case 'DEINIT_EXCHANGE_COUPON': {
      return exchangeCouponInitialState;
    }

    default:
      return state;
  }
}

export default combineReducers({
  exchangeCoupon: exchangeCouponReducer,
});
